export enum ActionTypes {
 GET_REPORT_FILTERS = '[GET_REPORT_FILTERS] Get report filters',
 GET_REPORT_FILTERS_SUCCESS = '[GET_REPORT_FILTERS] Get report filters success',
 GET_REPORT_FILTERS_FAILURE = '[GET_REPORT_FILTERS] Get report filters failure',
}
